module.exports = __webpack_public_path__ + "media/images/icons/country_flags/sh-hl-bc57860ab39ffdaf51263e6f50c8ffe0.svg";